module.exports = "/Users/modetojoy/work/10gen/compass-server-version/lib/assets/images/fontawesome-webfont__-xPow.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/font-awesome/fonts/fontawesome-webfont.woff2?v=4.7.0
// module id = 15
// module chunks = 0